module.exports = __webpack_public_path__ + "9bb2bd55d2e318db7cbb329e8bf9fc5d.png";